import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { GetCompaniesUsingPolicyResponse } from '@/api/agency/policy/get-companies-using-policy'

export const mockGetCompaniesUsingPolicy = http.get(
  '/my-business/api/agency/v1/*/:companyAlphaId/policies/:policyAlphaId/in-use',
  () => {
    const data: GetCompaniesUsingPolicyResponse = {
      companyId: faker.number.int({ min: 1, max: 1000 }),
      companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
      hierarchy: 'AGENCY_CHAIN',
      name: faker.company.name(),
      parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
      policyAlphaId: faker.string.uuid(),
      companies: {
        AGENCY: [
          {
            companyId: faker.number.int({ min: 1, max: 1000 }),
            companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
            hierarchy: 'AGENCY',
            name: faker.company.name(),
            parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
            policyAlphaId: faker.string.uuid(),
            companies: {
              POINT_OF_SALES: [
                {
                  companyId: faker.number.int({ min: 1, max: 1000 }),
                  companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
                  hierarchy: 'POINT_OF_SALES',
                  name: faker.company.name(),
                  parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
                  policyAlphaId: faker.string.uuid(),
                },
                {
                  companyId: faker.number.int({ min: 1, max: 1000 }),
                  companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
                  hierarchy: 'POINT_OF_SALES',
                  name: faker.company.name(),
                  parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
                  policyAlphaId: faker.string.uuid(),
                },
                {
                  companyId: faker.number.int({ min: 1, max: 1000 }),
                  companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
                  hierarchy: 'POINT_OF_SALES',
                  name: faker.company.name(),
                  parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
                  policyAlphaId: faker.string.uuid(),
                },
              ],
            },
          },
          {
            companyId: faker.number.int({ min: 1, max: 1000 }),
            companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
            hierarchy: 'AGENCY',
            name: faker.company.name(),
            parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
            policyAlphaId: faker.string.uuid(),
            companies: {
              POINT_OF_SALES: [
                {
                  companyId: faker.number.int({ min: 1, max: 1000 }),
                  companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
                  hierarchy: 'POINT_OF_SALES',
                  name: faker.company.name(),
                  parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
                  policyAlphaId: faker.string.uuid(),
                },
                {
                  companyId: faker.number.int({ min: 1, max: 1000 }),
                  companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
                  hierarchy: 'POINT_OF_SALES',
                  name: faker.company.name(),
                  parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
                  policyAlphaId: faker.string.uuid(),
                },
                {
                  companyId: faker.number.int({ min: 1, max: 1000 }),
                  companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
                  hierarchy: 'POINT_OF_SALES',
                  name: faker.company.name(),
                  parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
                  policyAlphaId: faker.string.uuid(),
                },
              ],
            },
          },
          {
            companyId: faker.number.int({ min: 1, max: 1000 }),
            companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
            hierarchy: 'AGENCY',
            name: faker.company.name(),
            parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
            policyAlphaId: faker.string.uuid(),
            companies: {
              POINT_OF_SALES: [
                {
                  companyId: faker.number.int({ min: 1, max: 1000 }),
                  companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
                  hierarchy: 'POINT_OF_SALES',
                  name: faker.company.name(),
                  parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
                  policyAlphaId: faker.string.uuid(),
                },
                {
                  companyId: faker.number.int({ min: 1, max: 1000 }),
                  companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
                  hierarchy: 'POINT_OF_SALES',
                  name: faker.company.name(),
                  parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
                  policyAlphaId: faker.string.uuid(),
                },
                {
                  companyId: faker.number.int({ min: 1, max: 1000 }),
                  companyPolicyId: faker.number.int({ min: 1, max: 1000 }),
                  hierarchy: 'POINT_OF_SALES',
                  name: faker.company.name(),
                  parentCompanyId: faker.number.int({ min: 1, max: 1000 }),
                  policyAlphaId: faker.string.uuid(),
                },
              ],
            },
          },
        ],
      },
    }

    return HttpResponse.json(data, { status: 200 })
  },
)
